import styled, { css, DefaultTheme } from 'styled-components';
import { darken } from 'polished';

import { ButtonProps } from '.';

type WrapperProps = {
  hasIcon: boolean;
} & Pick<
  ButtonProps,
  | 'size'
  | 'fullWidth'
  | 'minimal'
  | 'outlined'
  | 'fitContent'
  | 'marginBottom'
  | 'marginLeft'
>;

const wrapperModifiers = {
  small: (theme: DefaultTheme) => css`
    height: 2rem;
    font-size: 14px;
    padding-right: 30px;
    padding-left: 30px;
  `,
  medium: (theme: DefaultTheme) => css`
    height: 3rem;
    font-size: 16px;
    padding: 10px;
    padding-right: 50px;
    padding-left: 50px;
  `,
  large: (theme: DefaultTheme) => css`
    display: flex !important;
    height: 5rem;
    font-size: 24px;
    padding: 10px;
    padding-right: 50px;
    padding-left: 50px;
    width: 300px;
  `,
  fullWidth: () => css`
    width: 100%;
  `,
  fitContent: () => css`
    width: fit-content;
  `,
  withIcon: (theme: DefaultTheme) => css`
    svg {
      width: 1.5rem;
      & + span {
        margin-left: 10px;
      }
    }
  `,
  outlined: (theme: DefaultTheme) => css`
    background: transparent;
    color: #FFFFFF;
    border: 2px solid #FFFFFF;
  `,
  minimal: (theme: DefaultTheme) => css`
    background: none;
    color: #E71037;
    &:hover {
      color: ${darken(0.1, '#E71037')};
    }
  `,
};

export const Container = styled.button<WrapperProps>`
  ${({
    theme,
    size,
    fullWidth,
    hasIcon,
    minimal,
    outlined,
    fitContent,
    marginBottom,
    marginLeft,
  }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #E71037;
    color: #FFFFFF;
    border: 0;
    height: 48px;
    cursor: pointer;
    border-radius: 15px;
    font-weight: 600;
    font-family: "Baloo 2";
    padding: 10px;
    text-decoration: none;

    margin-left: ${marginLeft ? `${marginLeft}px` : '0px'};
    margin-bottom: ${marginBottom ? `${marginBottom}px` : '0px'};
    ${!!size && wrapperModifiers[size](theme)};
    ${!!fullWidth && wrapperModifiers.fullWidth()};
    ${!!fitContent && !fullWidth && wrapperModifiers.fitContent()};
    ${!!hasIcon && wrapperModifiers.withIcon(theme)};
    ${!!minimal && wrapperModifiers.minimal(theme)};
    ${!!outlined && wrapperModifiers.outlined(theme)};

    &:disabled {
      background: #f3879b;
      ${!!outlined && wrapperModifiers.outlined(theme)};
      cursor: not-allowed;
    }
  `}
`;
